// eslint-disable-next-line import/no-anonymous-default-export
export default {
    LOADING: 'auth/loading',
    LOGIN_SUCCESSS: 'auth/login/success',
    LOGIN_FAILED: 'auth/login/failed',
    LOAD_USER_SUCCESS: 'auth/load_user/success',
    LOAD_USER_FAILED: 'auth/load_user/failed',
    LOGOUT: 'auth/logout',
    UPDATE_TOKEN: 'auth/update_token',
};
